module.exports = __webpack_public_path__ + "static/media/MVNZ_web_2.55c2ed3d.jpg";